import PropTypes from "prop-types";
import React, { useContext } from "react";
import Header from "./header";
import Footer from "./footer";
import SiteMetaContext from "../../../contexts/SiteMetaContext";
import * as theme2Styles from "../scss/theme2.module.scss";
// import "../css/theme2.css";

function Layout({ children }) {
  const siteData = useContext(SiteMetaContext);

  const {
    remarso: {
      domainByURL: {
        website: {
          theme: colorTheme = "theme-default",
          setting: display_settings,
        },
      },
    },
  } = siteData;

  // let themeColor = `${theme2Styles.themeGreen}`;
  // if (colorTheme == "theme-blue") {
  //   themeColor = `${theme2Styles.themeBlue}`;
  // } else if (colorTheme == "theme-white") {
  //   themeColor = `${theme2Styles.themeWhite}`;
  // } else if (colorTheme == "theme-orange") {
  //   themeColor = `${theme2Styles.themeOrange}`;
  // } else if (colorTheme == "theme-red") {
  //   themeColor = `${theme2Styles.themeRed}`;
  // }

  let themeColor = `${theme2Styles.themeDefault}`;
  if (colorTheme == "theme-blue") {
    themeColor = `${theme2Styles.themeBlue}`;
  } else if (colorTheme == "theme-white") {
    themeColor = `${theme2Styles.themeWhite}`;
  } else if (colorTheme == "theme-red") {
    themeColor = `${theme2Styles.themeRed}`;
  } else if (colorTheme == "theme-orange") {
    themeColor = `${theme2Styles.themeOrange}`;
  } else if (colorTheme == "theme-yellow") {
    themeColor = `${theme2Styles.themeYellow}`;
  } else if (colorTheme == "theme-green") {
    themeColor = `${theme2Styles.themeGreen}`;
  } else if (colorTheme == "theme-purple") {
    themeColor = `${theme2Styles.themePurple}`;
  }

  const { display_footer } = display_settings;

  const wrapperClass = `flex flex-col min-h-screen font-sans text-gray-900 ${themeColor}`;

  return (
    <div className={wrapperClass}>
      <Header />
      <main className="">{children}</main>
      {(() => {
        if (display_footer) {
          return <Footer />;
        }
      })()}
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
